import { useEffect, useRef, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/auth';
import { useWorkspaceStore } from '@/shared/store/workspace';
import MinitokenGate from './MinitokenGate';

interface LogoutQueryHandlerProps {
  children: ReactNode;
}

export function LogoutQueryHandler({ children }: LogoutQueryHandlerProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const handledLogout = useRef(false);
  const shouldLogout =
    location.pathname === '/login' &&
    new URLSearchParams(location.search).get('logout') === 'true';

  useEffect(() => {
    if (!shouldLogout || handledLogout.current) return;
    handledLogout.current = true;

    queryClient.clear();
    useWorkspaceStore.getState().reset();
    useAuthStore.getState().reset();
    navigate('/login', { replace: true });
  }, [navigate, queryClient, shouldLogout]);

  if (shouldLogout) return null;

  return <MinitokenGate>{children}</MinitokenGate>;
}
